import {Quill} from 'react-quill';
import { loadTwitterScript } from './twitter/loadTwitterScript';
import { cleanTweetURL } from './twitter/twitterUtils';

const BlockEmbed = Quill.import('blots/block/embed');

// const BaseBlock = Quill.import('blots/embed');

class TwitterBlot extends BlockEmbed {
	static create(data) {

		const cleanedUrl = cleanTweetURL(data.url);

		const node = super.create(data);

		  loadTwitterScript().then(() => {
			window.twttr.widgets.load(node.parentNode);
		  }).catch(error => console.error('Erreur de chargement du script Twitter:', error));

		  const innerHTML = `
		  <div style="display: flex; max-width: 100%;" contentEditable="false">
			<blockquote class="twitter-tweet">
			  <a href="${cleanedUrl}" tabIndex="-1">Voir le Tweet</a>
			</blockquote>
		  </div>
		`;
	
		node.innerHTML = innerHTML;
		// store data
		node.setAttribute('data-url', cleanedUrl);
		return node;
	}

	static value(domNode) {
		const { url } = domNode.dataset;
		return { url };
	}

	index() {
		return 1;
	}

}

TwitterBlot.blotName = 'twitter';
TwitterBlot.tagName = 'div';
TwitterBlot.className = 'ql-tweet';

Quill.register(TwitterBlot)

export default TwitterBlot